import React, { useEffect, useRef, useState } from "react";
import {
  ColorIcon,
  colors,
  VStack,
  NextLink,
  responsive,
  Button,
  HStack,
  useResponsive,
  kakaoPixel,
  daangnPixelTrack,
  customEvent,
  tossPixel,
  pixelCustomEvent,
  PixelEventName,
  tiktokPixelTrack,
  Image,
  getCdnImageSrc,
  useCustomVariation,
} from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { BaseButton } from "goi_common/src/design-system/components/BaseButton";

import { useRouter } from "next/router";

import ReviewSection from "./compnents/ReviewSection";
import Footer from "./compnents/Footer";

import ProductPaymentProcessImage from "@/containers/registration/components/ProductPriceContainer/ProductPaymentProcessImage";

import { Flex, Box } from "@chakra-ui/react";

import NewHeroSection from "./compnents/NewHeroSection";
import NewBenefitSection from "./compnents/NewBenefitSection";
import LandingFixedTwinButton from "@/components/common/LandingFixedTwinButton";
import useIntersectionObserver from "goi_common/src/hooks/useIntersectionObserver";
import CompareSection from "./compnents/CompareSection";
import FAQSection from "./compnents/FAQSection";
import { keyframes } from "@emotion/react";
import ConsultFAB from "@/components/consult/ConsultFAB";
import useLandingPageScroll from "@/hooks/useLandingPageScroll";
import useFunnelRouteDeclare from "@/hooks/useFunnelRouteDeclare";
import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";
import { appendFnk } from "@/utils/appendFnk";

import { 가족장2026 } from "goi_common/src/constants/servicePackages/service2026/가족장";
import { 무빈소장2026 } from "goi_common/src/constants/servicePackages/service2026/무빈소장";
import { 일반장2026 } from "goi_common/src/constants/servicePackages/service2026/일반장";
import { naverConversionEvent } from "@/utils/naverPageView";
import { PRODUCT_GROUP } from "@/constants/productKey";
import useLandingPageEffect from "@/hooks/useLandingPage";

import { sessionStorage, storageKeys } from "@/utils/storage";
import { getVisitCount } from "@/hooks/useFomoState";

const TRUST_INTRO_BASE_PATH = `/registration/trust-intro/?productGroup=${PRODUCT_GROUP["100"]}`;

const bounceAnimation = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const services = ["무빈소장" as const, "가족장" as const, "일반장" as const];
const servicePackagesDetail = {
  무빈소장: 무빈소장2026,
  가족장: 가족장2026,
  일반장: 일반장2026,
};
const items = [
  "가격" as const,
  "접객도우미" as const,
  "장례 용품" as const,
  "장의 차량" as const,
];
const suffix: Partial<Record<typeof items[number], string>> = {
  가격: "만 원",
  "장의 차량": "대",
};

function ServiceSection() {
  const { isBiggerThanLg } = useResponsive();
  return (
    <VStack
      width="100%"
      alignItems="center"
      background={colors.gray50}
      css={responsive({
        padding: {
          base: "40px 24px 60px",
          lg: "80px 24px",
        },
      })}
    >
      <ColorIcon
        name="icon-match-file"
        color=""
        size={isBiggerThanLg ? 66 : 56}
      />
      <Box
        className="gray900"
        css={responsive({
          fontSize: { base: "24px", lg: "42px" },
          paddingTop: { base: "10px", lg: "16px" },
          fontWeight: "bold",
        })}
        id="service"
      >
        100원 상조 서비스 상세
      </Box>
      <Box
        className="gray600"
        css={responsive({
          fontSize: { base: "14px", lg: "21px" },
          padding: { base: "20px 0px", lg: "40px 0px 20px" },
          textAlign: "center",
        })}
      >
        <b>
          장례 발생시 무빈소장, 가족장, 일반장 중{" "}
          <br className="lg_over_hidden" />
          상품을 선택
        </b>
        하시면 되며, <br />월 100원으로 현재 상품 가격을{" "}
        <br className="lg_over_hidden" />
        장례 시점까지 보장받을 수 있습니다.
      </Box>

      <Box
        css={responsive({
          width: "100%",
          maxWidth: { base: "360px", lg: "600px" },
        })}
      >
        <ProductPaymentProcessImage />
      </Box>

      <HStack
        gap={isBiggerThanLg ? "20px" : "10px"}
        css={responsive({
          margin: { base: "0px 0 20px", lg: "20px 0 40px" },
        })}
      >
        {services.map((name) => (
          <VStack
            gap={isBiggerThanLg ? "4px" : "0px"}
            key={name}
            alignItems="center"
          >
            <Flex
              id={name}
              css={responsive({
                minHeight: "55px",
                color: colors.brown650,
                alignItems: "center",
                fontSize: { base: "16px", lg: "21px" },
                fontWeight: "600",
              })}
            >
              {name}
            </Flex>
            <VStack
              borderRadius={10}
              gap={isBiggerThanLg ? 30 : 20}
              background={colors.white}
              boxShadow={"0px 0px 12px 0px rgba(0, 0, 0, 0.1)"}
              flexGrow={1}
              css={responsive({
                width: { base: "105px", lg: "190px" },
                padding: { base: "16px 8px", lg: "24px 13px" },
              })}
            >
              {items.map((a) => (
                <VStack key={a} alignItems="center">
                  <div
                    css={responsive({
                      color: colors.gray600,
                      fontSize: { base: "12px", lg: "16px" },
                    })}
                  >
                    {a}
                  </div>
                  <div
                    className="subtitle_14_b lg_subtitle_18_b"
                    css={responsive({
                      fontSize: { base: "14px", lg: "18px" },
                      color: colors.gray800,
                    })}
                  >
                    {servicePackagesDetail[name][a]}
                    {suffix[a]}
                  </div>
                </VStack>
              ))}
            </VStack>
          </VStack>
        ))}
      </HStack>

      <NextLink
        href="/service/"
        event={{
          newGtm: { path: "home", trigger_and_target: "uv_service" },
        }}
      >
        <Button
          className="body_16_m md_head_24_m"
          css={responsive({
            border: `1px solid ${colors.gray200}`,
            borderRadius: "12px",
            background: colors.white,
            color: colors.gray900,
            padding: { base: "12px 20px", md: "16px 33px" },
            marginTop: { base: "24px", md: "40px" },
          })}
        >
          상품 자세히 보기
        </Button>
      </NextLink>
    </VStack>
  );
}

interface HomeV2ContainerProps {
  additionalQueryParams?: string;
  funnelKey?: string;
  topBanner?: React.ReactNode;
}

export default function HomeV2Container(props: HomeV2ContainerProps = {}) {
  const { additionalQueryParams, funnelKey } = props;
  const router = useRouter();
  const { isBiggerThanMd } = useResponsive();

  const funnelKeyValue = funnelKey || landingFunnelKey.GROUP["100"];
  const isFromExistingSubscriber = router.query.from === "existing_subscriber";

  const { paths } = useFunnelRouteDeclare({
    uniqueKey: funnelKeyValue,
  });

  useLandingPageEffect();

  const { isHeroSectionVisible, heroSectionScrollTriggerRef } =
    useLandingPageScroll({
      verificationHref: `${paths.verification}`,
    });

  const [isArrowVisible, setIsArrowVisible] = useState(true);
  const [fabPhase, setFabPhase] = useState<
    "benefit" | "service" | "compare" | "review" | null
  >(null);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setHasScrolled(true);
    window.addEventListener("scroll", handleScroll, { once: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const newBenefitSectionRef = useRef<HTMLDivElement>(null);
  const serviceSectionRef = useRef<HTMLDivElement>(null);
  const compareSectionRef = useRef<HTMLDivElement>(null);
  const reviewSectionRef = useRef<HTMLDivElement>(null);

  useIntersectionObserver({
    root: null,
    target: heroSectionScrollTriggerRef,
    onIntersect: () => {
      setIsArrowVisible(false);
    },
    onNotIntersect: () => {},
    threshold: 0.1,
  });

  useIntersectionObserver({
    root: null,
    target: newBenefitSectionRef,
    onIntersect: () => setFabPhase((prev) => prev ?? "benefit"),
    threshold: 0.1,
    enabled: hasScrolled,
  });

  useIntersectionObserver({
    root: null,
    target: serviceSectionRef,
    onIntersect: () =>
      setFabPhase((prev) => (prev === "compare" ? prev : "service")),
    threshold: 0.1,
    enabled: hasScrolled,
  });

  useIntersectionObserver({
    root: null,
    target: compareSectionRef,
    onIntersect: () =>
      setFabPhase((prev) => (prev === "review" ? prev : "compare")),
    threshold: 0.1,
  });

  useIntersectionObserver({
    root: null,
    target: reviewSectionRef,
    onIntersect: () => setFabPhase("review"),
    threshold: 0.1,
  });

  const targetPath =
    paths["product-intro"] ||
    `/registration/product-intro/?productGroup=${PRODUCT_GROUP["100"]}`;

  const pathWithFnk = appendFnk(targetPath, funnelKeyValue);

  const finalPath = additionalQueryParams
    ? `${pathWithFnk}&${additionalQueryParams}`
    : pathWithFnk;

  const trustIntroPathWithFnk = appendFnk(
    TRUST_INTRO_BASE_PATH,
    funnelKeyValue
  );
  const trustIntroFinalPath = additionalQueryParams
    ? `${trustIntroPathWithFnk}&${additionalQueryParams}`
    : trustIntroPathWithFnk;

  const verificationPathWithFnk = appendFnk(
    paths.verification ||
      `/registration/verification/?productGroup=${PRODUCT_GROUP["100"]}`,
    funnelKeyValue
  );
  const verificationFinalPath = additionalQueryParams
    ? `${verificationPathWithFnk}&${additionalQueryParams}`
    : verificationPathWithFnk;

  const isAdsDiscountCampaign =
    sessionStorage.get(storageKeys.AdsDiscountCampaign) === "true";
  const isTmCampaign =
    sessionStorage.get(storageKeys.AdsDiscountCampaignIsTm) === "true";

  const ctaPath = isFromExistingSubscriber
    ? verificationFinalPath
    : isAdsDiscountCampaign && !isTmCampaign
    ? trustIntroFinalPath
    : finalPath;

  const heroCTADest = isFromExistingSubscriber
    ? verificationFinalPath
    : getVisitCount() >= 2
    ? trustIntroFinalPath
    : ctaPath;

  const variation309 = useCustomVariation(309);
  const isExp309B = variation309 === "B";

  if (variation309 === "Z") return null;

  return (
    <VStack css={{ color: colors.white, overflowX: "hidden" }}>
      {isExp309B ? (
        <Box position="relative" width="100%">
          <Image
            src={getCdnImageSrc(
              isBiggerThanMd
                ? "direct/home/oxquiz/0-4.png"
                : "direct/home/oxquiz/0-3.png"
            )}
            width="100%"
            height="auto"
            alt="100원만 있으면 평생 오르지 않는 장례 비용"
          />
          {isBiggerThanMd ? (
            <Box
              position="absolute"
              bottom="26%"
              left="44%"
              width="max-content"
              maxWidth="52%"
            >
              <BaseButton
                type="primary"
                size="large"
                onClick={() => {
                  customEvent({
                    newGtm: { path: "home", trigger_and_target: "CTA" },
                  });
                  customEvent({
                    newGtm: {
                      path: "home",
                      trigger_and_target: "hero_CTA-uv_registration",
                    },
                  });
                  naverConversionEvent({ type: "view_product" });
                  naverConversionEvent({ type: "lead" });
                  kakaoPixel()?.participation();
                  tossPixel()?.productView();
                  daangnPixelTrack("ViewContent");
                  tiktokPixelTrack("ViewContent");
                  pixelCustomEvent(PixelEventName.ViewContent);
                  router.push(heroCTADest);
                }}
              >
                {/* BaseButton 기본 좌우 padding 16px + 16px = 32px */}
                <Box padding="0 16px">
                  평생 같은 비용으로 장례 서비스 이용하기
                </Box>
              </BaseButton>
            </Box>
          ) : (
            <Box
              position="absolute"
              bottom="13%"
              left="50%"
              transform="translateX(-50%)"
              width="max-content"
              maxWidth="calc(100% - 32px)"
            >
              <BaseButton
                type="primary"
                size="large"
                onClick={() => {
                  customEvent({
                    newGtm: { path: "home", trigger_and_target: "CTA" },
                  });
                  customEvent({
                    newGtm: {
                      path: "home",
                      trigger_and_target: "hero_CTA-uv_registration",
                    },
                  });
                  naverConversionEvent({ type: "view_product" });
                  naverConversionEvent({ type: "lead" });
                  kakaoPixel()?.participation();
                  tossPixel()?.productView();
                  daangnPixelTrack("ViewContent");
                  tiktokPixelTrack("ViewContent");
                  pixelCustomEvent(PixelEventName.ViewContent);
                  router.push(heroCTADest);
                }}
              >
                평생 같은 비용으로 장례 서비스 이용하기
              </BaseButton>
            </Box>
          )}
        </Box>
      ) : (
        <>
          <NewHeroSection
            hasCTA={false}
            padding={{ base: "48px 0 0", md: "52px 0 0" }}
          />
          <VStack background="#FFEACC" alignItems="center" padding="0px 0 52px">
            <BaseStack direction="horizontal" spacing={8}>
              <NextLink href={heroCTADest}>
                <Button
                  className="body_16_m md_head_24_m"
                  onClick={() => {
                    customEvent({
                      newGtm: { path: "home", trigger_and_target: "CTA" },
                    });
                    customEvent({
                      newGtm: {
                        path: "home",
                        trigger_and_target: "hero_CTA-uv_registration",
                      },
                    });
                    naverConversionEvent({ type: "view_product" });
                    naverConversionEvent({ type: "lead" });
                    kakaoPixel()?.participation();
                    tossPixel()?.productView();
                    daangnPixelTrack("ViewContent");
                    tiktokPixelTrack("ViewContent");
                    pixelCustomEvent(PixelEventName.ViewContent);
                  }}
                  css={responsive({
                    border: `1px solid ${colors.orange650}`,
                    borderRadius: "8px",
                    background: colors.orange650,
                    color: colors.white,
                    padding: { base: "12px 31px", md: "16px 46px" },
                    marginTop: { base: "16px", md: "20px" },
                  })}
                >
                  3분만에 간편가입
                </Button>
              </NextLink>
            </BaseStack>
          </VStack>
        </>
      )}

      <div ref={newBenefitSectionRef}>
        <NewBenefitSection />
      </div>

      <div ref={heroSectionScrollTriggerRef}></div>

      <div ref={serviceSectionRef}>
        <ServiceSection />
      </div>

      {/* <AboutSection /> */}
      <div ref={compareSectionRef}>
        <CompareSection />
      </div>

      <div ref={reviewSectionRef}>
        <ReviewSection />
      </div>
      {/* <NumberOneSection />
      <CollaborationSection />
      <PRSection /> */}
      <FAQSection />

      <Footer />
      {!isHeroSectionVisible && (
        <LandingFixedTwinButton
          text={
            isExp309B
              ? "평생 같은 비용으로 장례 서비스 이용하기"
              : "100원 상조로 장례 준비하기"
          }
          href={heroCTADest}
          onCtaClick={() => naverConversionEvent({ type: "lead" })}
        />
      )}

      {isArrowVisible && (
        <Box
          position="fixed"
          bottom="20px"
          right="0px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="0px"
          justifyContent="center"
          width="100%"
          zIndex={1000}
          animation={`${bounceAnimation} 1.25s infinite`}
        >
          <VStack>
            <ColorIcon
              name="arrow_right_small"
              css={{
                transform: "translateY(0px) translateX(20px)",
                rotate: "90deg",
              }}
              size={34}
              color={colors.warmGray650}
            />
            <ColorIcon
              name="arrow_right_small"
              css={{ transform: "translateY(0px)", rotate: "90deg" }}
              size={34}
              color={colors.warmGray650}
            />
          </VStack>
        </Box>
      )}

      {fabPhase !== null && <ConsultFAB />}
    </VStack>
  );
}
